import { SocratesImage, } from '@socrates/common';

export abstract class IImagesRepo {
	abstract postImage(urlPath: string, imageData: SocratesImage): Promise<SocratesImage>;
	abstract pullImage(urlPath: string, forcePull: boolean): Promise<SocratesImage>;
	abstract pullRootImage(urlPath: string): Promise<SocratesImage>;
	abstract pullAddressImage(urlPath: string, position: any): Promise<SocratesImage>;
	abstract removeImage(urlPath: string): Promise<boolean>;
	abstract tunnelImage(imageUrl: string): Promise<SocratesImage>;
}
